import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import * as React from 'react';
import YearHeader from './YearHeader';
import YearBody, { YEAR_COL_COUNT } from './YearBody';
import { createKeyDownHandler } from '../../utils/uiUtil';
export var YEAR_DECADE_COUNT = 10;

function YearPanel(props) {
  var prefixCls = props.prefixCls,
      operationRef = props.operationRef,
      onViewDateChange = props.onViewDateChange,
      generateConfig = props.generateConfig,
      value = props.value,
      viewDate = props.viewDate,
      sourceMode = props.sourceMode,
      _onSelect = props.onSelect,
      onPanelChange = props.onPanelChange,
      diffValue = props.diffValue,
      headerSelect = props.headerSelect,
      showSelectMask = props.showSelectMask;
  var panelPrefixCls = "".concat(prefixCls, "-year-panel"); // ======================= Keyboard =======================

  operationRef.current = {
    onKeyDown: function onKeyDown(event) {
      return createKeyDownHandler(event, {
        onLeftRight: function onLeftRight(diff) {
          _onSelect(generateConfig.addYear(value || viewDate, diff), 'key');
        },
        onCtrlLeftRight: function onCtrlLeftRight(diff) {
          _onSelect(generateConfig.addYear(value || viewDate, diff * YEAR_DECADE_COUNT), 'key');
        },
        onUpDown: function onUpDown(diff) {
          _onSelect(generateConfig.addYear(value || viewDate, diff * YEAR_COL_COUNT), 'key');
        },
        onEnter: function onEnter() {
          onPanelChange('month', value || viewDate);
        }
      });
    }
  }; // ==================== View Operation ====================

  var onDecadeChange = function onDecadeChange(diff) {
    var newDate = generateConfig.addYear(viewDate, diff * 10);
    onViewDateChange(newDate);
    onPanelChange(null, newDate, 'year', diff);
  };

  var _React$useState = React.useState(sourceMode),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      sourceModeCopy = _React$useState2[0],
      setSourceModeCopy = _React$useState2[1];

  React.useEffect(function () {
    if (sourceMode && ['date', 'week', 'quarter', 'year', 'halfYear', 'month'].includes(sourceMode)) {
      setSourceModeCopy('decade');
    }
  }, [sourceMode]);
  React.useEffect(function () {
    if (diffValue) {
      onDecadeChange(diffValue[0]);
    }
  }, [diffValue]);
  return /*#__PURE__*/React.createElement("div", {
    className: panelPrefixCls
  }, /*#__PURE__*/React.createElement(YearHeader, _extends({}, props, {
    prefixCls: prefixCls,
    onPrevDecade: function onPrevDecade() {
      onDecadeChange(-1);
    },
    onNextDecade: function onNextDecade() {
      onDecadeChange(1);
    },
    onDecadeClick: function onDecadeClick() {
      onPanelChange('decade', viewDate);
    },
    sourceModeCopy: sourceModeCopy
  })), /*#__PURE__*/React.createElement(YearBody, _extends({}, props, {
    prefixCls: prefixCls,
    onSelect: function onSelect(date) {
      onPanelChange('month', date);

      _onSelect(date, 'mouse');
    }
  })), headerSelect != undefined && showSelectMask ? /*#__PURE__*/React.createElement("div", {
    style: {
      opacity: '0.5',
      width: '100%',
      height: '100%',
      background: '#fff',
      position: 'absolute',
      left: 0,
      zIndex: '100'
    }
  }) : null);
}

export default YearPanel;